import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export function resolveFlatResourceFallback(bundle, key) {
  if (!bundle || typeof bundle !== 'object' || typeof key !== 'string' || !key) {
    return undefined;
  }
  if (Object.prototype.hasOwnProperty.call(bundle, key)) {
    return bundle[key];
  }
  const workflow = bundle.workflow;
  if (workflow && typeof workflow === 'object') {
    if (Object.prototype.hasOwnProperty.call(workflow, key)) {
      return workflow[key];
    }
    if (key.startsWith('workflow.')) {
      const stripped = key.slice('workflow.'.length);
      if (Object.prototype.hasOwnProperty.call(workflow, stripped)) {
        return workflow[stripped];
      }
    } else {
      const prefixed = `workflow.${key}`;
      if (Object.prototype.hasOwnProperty.call(workflow, prefixed)) {
        return workflow[prefixed];
      }
    }
  }
  return undefined;
}

if (process.env.NODE_ENV !== 'test') {
  i18n.use(HttpApi);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'fr'],
    fallbackLng: 'en',
    detection: {
      order: ['cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['cookie', 'localStorage'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json?v=action-test-inputs-20261024',
    },
    react: {
      useSuspense: false,
    },
  });

const resourceStore = i18n.services?.resourceStore;
if (resourceStore && typeof resourceStore.getResource === 'function') {
  const originalGetResource = resourceStore.getResource.bind(resourceStore);
  resourceStore.getResource = (lng, ns, key, options) => {
    const resolved = originalGetResource(lng, ns, key, options);
    if (resolved !== undefined || !key) {
      return resolved;
    }
    const bundle = resourceStore.data?.[lng]?.[ns];
    return resolveFlatResourceFallback(bundle, key);
  };
}

export default i18n;
